// src/json/overlayData.json
export const overlaySectionWindowsCleaning = {
    imageUrl: "/assets/imgs/services/11WindowsCleaning/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
